import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    zoomIn: {
      transition: 'transform 0.3s',
      '&:hover': {
        transform: 'scale(1.2)',
        fontWeight:600,
        fontSize:12,
        marginLeft:4,
        textTransform:'uppercase' // Adjust the scale factor for the desired zoom level
      },
      fontWeight:500,
    },
  }));


  export {useStyles}